<template>
  <base-message :message="message" :full-width="true">
    <video v-if="message.data.src.startsWith('http://192.168.1.138:8081')"
           v-show="message.status !== 'error'"
           :src="message.data.src"
           @keydown="keydown"
           controls></video>
    <div class="video-message">
      <div :id="'prism-player-' + _uid"
           class="prism-player"></div>
    </div>
    <div
        class="video-commands">
      <div class="buttons one-line">
        <button
            v-if="showNext"
            @click="next"
            class="button is-white is-small">
          <v-color-icon name="arrow-down-s"></v-color-icon>
          <span>继续课堂内容</span>
        </button>
      </div>
    </div>
  </base-message>
</template>

<script>
import BaseMessage from './BaseMessage'
import IClassroom from '@/components/classroom/lib/IClassroom'

export default {
  components: { BaseMessage },
  props: ['message'],
  data () {
    return {
      player: {},
      errorCount: 0,
      playing: false,
      IClassroom,
      needBrowserPlay: false,
      showNext: true
    }
  },
  computed: {
    isLastMessage () {
      return IClassroom.lastCourseMessage && IClassroom.lastCourseMessage.id === this.message.id
    }
  },
  async mounted () {
    try {
      const src = this.message.data.src
      // src = `{"SD":"http://192.168.1.138:8083/Intro.mp4","HD":"${src}"}`
      // eslint-disable-next-line no-undef
      this.player = new Aliplayer({
        id: 'prism-player-' + this._uid,
        autoplay: true,
        width: '100%',
        height: '0',
        source: src,
        skinLayout: [
          {
            name: 'controlBar', align: 'blabs', x: 0, y: 0,
            children: [
              { name: 'progress', align: 'blabs', x: 0, y: 44 },
              { name: 'playButton', align: 'tl', x: 15, y: 12 },
              { name: 'timeDisplay', align: 'tl', x: 10, y: 5 },
              { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
              { name: 'setting', align: 'tr', x: 15, y: 12 },
              { name: 'speedButton', align: 'tr', x: 15, y: 12 },
              { name: 'volume', align: 'tr', x: 15, y: 10 }
            ]
          }
        ]
      }, (player) => {
        player.on('canplay', () => {

        })
        player.on('play', () => {
          this.playing = true
          window.addEventListener('keydown', this.keydown)
        })
        player.on('pause', () => {
          this.playing = false
          const current = player.getCurrentTime()
          const duration = player.getDuration()
          if (duration && (duration - current < 3)) {
            if (document.fullscreenElement) {
              if (document.exitFullscreen) {
                document.exitFullscreen()
              } else if (document.msExitFullscreen) {
                document.msExitFullscreen()
              } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
              } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
              }
              window.removeEventListener('keydown', this.keydown)
            }

            // this.next()
          }
        })
      })
      this.player.on('error', async (e) => {
        this.errorCount++
        if (this.errorCount < 2) {
          if (e.paramData.error_code === 4400) {
            this.player.loadByUrl(this.message.data.src)
            return
          }
          const msgElements = document.getElementsByClassName('prism-ErrorMessage')
          msgElements.forEach(ele => {
            ele.innerHTML = `<div class="prism-error-operation"><a class="prism-button prism-button-refresh" onclick="window.postMessage('videoError')">刷新</a></div>`
          })
        } else {
          const msgElements = document.getElementsByClassName('prism-ErrorMessage')
          msgElements.forEach(ele => {
            ele.innerHTML = `<div class="prism-error-content"><p>视频地址已过期，请刷新页面重新播放</p></div>`
          })
        }
      })
    } catch (e) {
      console.log('video error ', e)
    }
  },
  methods: {
    next () {
      this.showNext = false
      if (this.playing) {
        this.player.pause()
      }
      IClassroom.requestNextMessage()
    },
    keydown (event) {
      if (event.key === ' ' && this.isLastMessage) {
        if (this.playing) {
          this.player.pause()
        } else {
          this.player.play()
        }
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keydown)
  }
}
</script>

<style lang="stylus" scoped>
.video-message {
  border-radius 3px 3px 0 0
  width 100%
  height 100%
  overflow hidden
  user-select none
}

.prism-player {
  width: 100vw
  height 0 !important
  padding-bottom: 56.25%;
  background white
}

.video-commands {
  padding .75rem
  background $neBg
}
</style>
